import { ModuleWithProviders, NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { CommonBackendModule } from "../common/common-backend.module";
import { PhoneNumbersApi } from "./api/numbers.api";
import { PhoneNumbersService } from "./services/phone-number.service";
import { PaymentsApi } from "./api/payment.api";
import { PaymentService } from "./services/payment-service";
import { ClientService } from "./services/client-service";
import { BalanceService } from "./services/balance-service";
import { SignUpApi } from "./api/sign-up-api";
import { AuthApi } from "./api/auth.api";
import { AuthService } from "./services/auth.service";
import { ReceptionistService } from "./services/receptionist-service";
import { ReceptionistApi } from "./api/receptionist-api";
import { ExportApi } from "./api/export.api";
import { PasswordApi } from "./api/password.api";
import { PasswordService } from "./services/pasword-service";
import { PricingService } from "./services/pricing-service";
import { PricingApi } from "./api/pricing.api";
import { StatementsService } from "./services/statements-service";
import { FranchiseApi } from "./api/franchise.api";
import { FranchiseService } from "./services/franchise-service";
import { FranchiseeApi } from "./api/franchisee.api";
import { FranchiseeService } from "./services/franchisee-service";
import { ColourService } from "./services/colour-service";
import { ResellerService } from "./services/reseller.service";
import { StripeConfigService } from "./services/stripe-config.service";
import { StripeContextService } from "./services/stripe-context.service";

const API = [
  PhoneNumbersApi,
  PricingApi,
  SignUpApi,
  AuthApi,
  PaymentsApi,
  ReceptionistApi,
  FranchiseApi,
  FranchiseeApi,
  ExportApi,
  PasswordApi,
];

const SERVICES = [
  PhoneNumbersService,
  PaymentService,
  BalanceService,
  ReceptionistService,
  ClientService,
  AuthService,
  ResellerService,
  FranchiseService,
  FranchiseeService,
  PhoneNumbersService,
  PricingService,
  PaymentService,
  PasswordService,
  StatementsService,
  ColourService,
  StripeConfigService,
  StripeContextService,
];

@NgModule({
  imports: [CommonModule, CommonBackendModule],
  exports: [CommonBackendModule],
})
export class ReceptionistBackendModule {
  static forRoot(): ModuleWithProviders<ReceptionistBackendModule> {
    return {
      ngModule: ReceptionistBackendModule,
      providers: [...API, ...SERVICES],
    };
  }
}
